import { portalApi } from '../../store/generated/portal/organization-context';
import { UserContextApiTags } from './userContextApi';
import userContextSlice from '../slices/userContextSlice';

export const organizationContextApi = portalApi.enhanceEndpoints({
  addTagTypes: [UserContextApiTags.OrganizationContext],
  endpoints: {
    apiPortalV1OrganizationContextRetrieve: {
      providesTags: [UserContextApiTags.OrganizationContext],
      keepUnusedDataFor: Infinity, // Never purge from cache
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(userContextSlice.actions.initializeOrganizationContext(data));
        } catch (err) {
          console.error('[ORG CONTEXT QUERY] Error:', err);
        }
      },
    },
  },
});

